import { core } from '@mockup/core.func';

import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
import Offcanvas from 'bootstrap/js/dist/offcanvas';

document.addEventListener('DOMContentLoaded', () => {
    core.init();
});

window.tillidssidenApp = window.tillidssidenApp || {};
const tApp = window.tillidssidenApp;

const ResultCommand = {
    Success: 'None',
    Message: 'Message',
    GoUrl: 'GoUrl',
    GoPost: 'GoPost'
};

tApp.PostValue = function (url, keyValuePairs) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    keyValuePairs.forEach(function (pair) {

        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = pair.key;
        input.value = pair.value;

        form.appendChild(input);
    });

    const tokenElm = document.querySelector('input[name="__RequestVerificationToken"]');
    if (tokenElm?.value) {
        const tokenInput = document.createElement('input');
        tokenInput.type = 'hidden';
        tokenInput.name = '__RequestVerificationToken';
        tokenInput.value = tokenElm.value;
        form.appendChild(tokenInput);
    }

    document.body.appendChild(form);
    form.submit();
};


/**
 * Handles the deserialized JSON response from the C# backend
 * @param {Object} result - The camelCased JSON object
 */
tApp.handleApiResponse = function (apiResultObj) {
    const resultObj = apiResultObj?.result ?? apiResultObj;

    if (resultObj && resultObj.status === 'cancelled') {
        return;
    }

    if (resultObj?.status && resultObj.success !== true) {
        const message = resultObj.errorMessage || 'Der opstod en ukendt fejl.';
        alert(message);
        return;
    }

    const result = resultObj?.result ?? resultObj;
    if (!result) {
        console.error('No result returned from API');
        return;
    }

    const showMessage = (msg) => alert(msg);
    const showSuccess = (msg) => showMessage(`Success: ${msg}`);
    const showError = (msg) => showMessage(`❌ Error: ${msg}`);
    const showValidationError = (msg) => showMessage(`⚠️ Validation Error: ${msg}`);

    function getErrorMessage() {
        let msg = '';
        if (result.message) msg += '\n' + result.message;
        if (result.errorDetails?.errorMessage) msg += '\n' + result.errorDetails.errorMessage;
        if (result.errorDetails?.errorType) msg += '\n' + `(${result.errorDetails.errorType}.)`;
        if (!msg) msg = 'Der opstod en ukendt fejl.';
        return 'Fejl: ' + msg;
    }

    function handleError() {
        if (!result.ok) {
            if (result.errorDetails) {
                console.error('API Error Details:', result.errorDetails);
                if (result.errorDetails == 'ValidationError') {
                    showValidationError(getErrorMessage());
                    return true;
                }
                if (result.errorDetails == 'ApiError') {
                    showError(getErrorMessage());
                    return true;
                }
                showError(getErrorMessage());
                return true;
            }
            showError(getErrorMessage());
            return true;
        }
        return false;
    }

    function handleCommand() {
        switch (result.commandStr) {
            case ResultCommand.Success:
                showSuccess(result.message || 'Data gemt.');
                break;
            case ResultCommand.Message:
                showMessage(result.message);
                break;
            case ResultCommand.GoUrl:
                if (result.actionUrl) {
                    window.location.href = result.actionUrl;
                } else {
                    console.error('Command was GoUrl, but ActionUrl was null');
                }
                break;
            case ResultCommand.GoPost:
                if (result.actionUrl && result.postValues) {
                    tApp.PostValue(result.actionUrl, result.postValues);
                }
                break;
            default:
                console.warn('Unknown ResultCommand received:', result.command);
                break;
        }
    }

    if (!handleError()) {
        handleCommand();
    }
};

export const tillidssidenApp = tApp;


